/**
 * Reset Password Component
 */

import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authAPI, partnerAPI, settingsAPI } from '../services/api';
import './Login.css';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;
  const istPartner = new URLSearchParams(location.search).get('bereich') === 'partner';
  const loginPfad = istPartner ? '/login?bereich=partner' : '/login';

  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [headerTitle, setHeaderTitle] = useState('Der Starke Franz');

  useEffect(() => {
    settingsAPI.getPublicSettings().then(res => {
      if (res.data?.header_title) setHeaderTitle(res.data.header_title);
    }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (otp.length !== 6) {
      setError('Bitte gib den 6-stelligen Code ein.');
      return;
    }

    if (password.length < 6) {
      setError('Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);

    try {
      await (istPartner ? partnerAPI : authAPI).resetPassword(email, otp, password);
      setSuccess(true);
      setTimeout(() => navigate(loginPfad), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ein Fehler ist aufgetreten. Bitte fordere einen neuen Code an.');
    }

    setLoading(false);
  };

  if (!email) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>{headerTitle}</h1>
          <h2>Kein Code angefordert</h2>
          <p style={{ color: '#475569', fontSize: '15px', textAlign: 'center', marginBottom: '24px' }}>
            Bitte fordere zuerst einen Code an.
          </p>
          <Link to={istPartner ? '/forgot-password?bereich=partner' : '/forgot-password'} style={{ display: 'block', textAlign: 'center', color: '#c87a3e', fontWeight: '600', fontSize: '14px' }}>
            Code anfordern
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>{headerTitle}</h1>
        <h2>Neues Passwort setzen</h2>

        {success ? (
          <div>
            <p style={{ color: '#16a34a', fontSize: '15px', textAlign: 'center', marginBottom: '24px' }}>
              Dein Passwort wurde erfolgreich geändert. Du wirst zum Login weitergeleitet...
            </p>
            <Link to={loginPfad} style={{ display: 'block', textAlign: 'center', color: '#c87a3e', fontWeight: '600', fontSize: '14px' }}>
              Zum Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: '#475569', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
              Wir haben einen Code an <strong>{email}</strong> gesendet.
            </p>

            <div className="form-group">
              <label>6-stelliger Code</label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                required
                placeholder="000000"
                style={{ textAlign: 'center', fontSize: '24px', letterSpacing: '8px', fontFamily: 'monospace' }}
              />
            </div>

            <div className="form-group">
              <label>Neues Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Mindestens 6 Zeichen"
              />
            </div>

            <div className="form-group">
              <label>Passwort bestätigen</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Passwort wiederholen"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" disabled={loading}>
              {loading ? 'Wird gespeichert...' : 'Passwort ändern'}
            </button>

            <Link to={istPartner ? '/forgot-password?bereich=partner' : '/forgot-password'} style={{ display: 'block', textAlign: 'center', color: '#c87a3e', fontWeight: '600', fontSize: '14px', marginTop: '20px' }}>
              Neuen Code anfordern
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
